import { TreeLevel } from 'components/DependencyTrees/CustomTreeLevel';
import { ReportItem } from 'store/ducks/Reporting/types';

export const processInventoryLevels: TreeLevel<ReportItem>[] = [
  {
    groupBy: (i) => `${i.l4_id ?? 'null'}`,
    getKey: (g) => `l4-${g}`,
    getLabel: (i) => i.l4_title ?? '-'
  },

  {
    groupBy: (i) => `${i.l4_id ?? 'null'}-${i.l3_id ?? 'null'}`,
    getKey: (g) => `l3-${g}`,
    getLabel: (i) => i.l3_title ?? '-'
  },

  {
    groupBy: (i) =>
      `${i.l4_id ?? 'null'}-${i.l3_id ?? 'null'}-${i.l2_id ?? 'null'}`,
    getKey: (g) => `l2-${g}`,
    getLabel: (i) => i.l2_title ?? '-'
  },

  {
    groupBy: (i) =>
      `${i.l4_id ?? 'null'}-${i.l3_id ?? 'null'}-${i.l2_id ?? 'null'}-${
        i.l1_id ?? 'null'
      }`,
    getKey: (g) => `l1-${g}`,
    getLabel: (i) => i.l1_title ?? '-'
  }
];
